/**
 * Extrahiert alle Formularwerte (input/textarea/select) als JSON-String.
 * Schlüssel ist die id (Fallback: name). Wird für form_data_vdz / form_data_ibn
 * in HubSpot verwendet.
 */
export const extractFormData = (doc: Document): string => {
  const formData: Record<string, string | boolean> = {};
  doc.querySelectorAll<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>('input, textarea, select').forEach((el) => {
    const id = el.id || el.name;
    if (id) {
      // Bewusst kein `instanceof HTMLInputElement`: Elemente eines iframe gehören zu dessen
      // eigenem Window, der Konstruktor des äußeren Windows würde nie greifen (Checkbox → "on").
      if (el.tagName === 'INPUT' && (el as HTMLInputElement).type === 'checkbox') formData[id] = (el as HTMLInputElement).checked;
      else formData[id] = el.value;
    }
  });
  return JSON.stringify(formData);
};
